__turbopack_context__.v({
  "banner": "oJ7tsq_banner",
  "content": "oJ7tsq_content",
  "dismissButton": "oJ7tsq_dismissButton",
  "image": "oJ7tsq_image",
  "link": "oJ7tsq_link",
});
